import { t } from "@lingui/macro";
import { HouseSimple, Lock, SidebarSimple } from "@phosphor-icons/react";
import { Button, Tooltip } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { Link } from "react-router-dom";

import { useBuilderStore } from "@/client/stores/builder";
import { useResumeStore } from "@/client/stores/resume";
import { constants } from "../../../../../constants";

const portalBase = (
  import.meta.env.VITE_HOME_NAVIGATION_LINK ?? "https://mybharat.gov.in"
).replace(/\/$/, "");

/*
 document.getElementById("mybharaturlid").href=myurl + "/reports/yuva_profile"
 document.getElementById("myaccount").href=myurl + "/users/edityuvaprofile"
 document.getElementById("viewprofile").href=myurl + "/reports/yuva_profile"
 document.getElementById("publicprofile").href=myurl + "/reports/public_profile"
 document.getElementById("logout").href=myurl + "/users/check_user_logout"
 document.getElementById("back_button").href=myurl + "/reports/yuva_profile"
*/

export const BuilderHeader = () => {
  const title = useResumeStore((state) => state.resume.title);
  const locked = useResumeStore((state) => state.resume.locked);
  const url = useResumeStore((state) => state.resume.data.basics.picture.url);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);
  let myurl = window.localStorage.getItem("http_host");
  let left: any = document.getElementsByClassName("sidebars")[0];
  if (left) {
    let data_state = left.getAttribute["data-state"];
    let abc: any = document.getElementsByClassName("bars-light")[0];
    abc.style.display = "block";
  }

  const onToggle = (side: "left" | "right") => {
    let abc: any = document.getElementsByClassName("bars-light")[0];
    abc.style.display = "none";
    abc = null;
    toggle(side);
  };

  let url_back: any = myurl + "/reports/yuva_profile";
  let myaccount = myurl + "/users/edityuvaprofile";
  let logout = myurl + "/users/check_user_logout";

  let public_profile = myurl + "/youth-profile";

  let n = window.location.href.lastIndexOf("/");
  let encodedurlparam = window.location.href.substring(n + 1);
  encodedurlparam = atob(encodedurlparam);
  encodedurlparam = atob(encodedurlparam);
  console.log("myyyyyyyyy:", encodedurlparam);

  let webheader = {
    display: "none",
    left: `${leftPanelSize}%`,
    right: `${rightPanelSize}%`,
  };
  let mobheader = {
    display: "none",
  };

  function getCookies() {
    return document.cookie.split("; ").reduce((acc: any, cookie) => {
      const [key, value] = cookie.split("=");
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {});
  }
  const cookies = getCookies();
  let mobile_app = cookies["mobile_app"];
  // if (encodedurlparam.indexOf("ML_208") > -1) {
  if (mobile_app == "1") {
    webheader = {
      display: "none",
      left: `${leftPanelSize}%`,
      right: `${rightPanelSize}%`,
    };
    mobheader = {
      display: "block",
    };
  } else {
    webheader = {
      display: "",
      left: `${leftPanelSize}%`,
      right: `${rightPanelSize}%`,
    };
    mobheader = {
      display: "none",
    };
  }

  return (
    <div>
      <div
        style={webheader}
        className={cn(
          "fixed inset-x-0 top-0 z-[60] h-16 backdrop-blur-lg lg:z-20 panel-all mobile-header-md-none",
          !isDragging && "transition-[left,right]",
        )}
      >
        <div className="flex h-full items-center justify-between px-4">
          <div className="container flex items-center justify-between container-full-width-xs">
            <div className="flex justify-between">
              <div className="back-button">
                <a href={`${portalBase}/youth-profile`} id="mobile_back_button">
                  <i className="fa-solid fa-arrow-left"></i>
                </a>
              </div>

              <div className="logo">
                {" "}
                <a href={portalBase} id="mybharaturlid" className="d-flex-beta">
                  <img
                    src={constants.logoUrl.mybharat}
                    width="120"
                    height="50"
                    alt="Reactive Resume"
                    className="rounded-sm"
                  />
                </a>
              </div>
            </div>
            <div style={{ float: "right" }}>
              <div className="username notification">
                <div id="notification-display">
                  <i className="fa-regular fa-bell"></i>
                </div>
              </div>
              <div className="dropdown">
                <div className="profile-wrapper">
                  <a className="adropbtn">
                    <img id="user_img" src={url} width="40" alt="data" />
                  </a>
                </div>
                <div className="dropdown-content">
                  {/* <a href={myaccount} id="beta_dash">
                  <i className="fa-solid fa-grip cus-fa-fa">&nbsp;</i> Dashboard
                  </a> */}
                  {/* <a href={myaccount} id="myaccount">
                    <i className="fa fa-user"></i> My Account
                  </a> */}
                  {/* <a href={url_back} id="viewprofile">
                    <i className="fa fa-user"></i> View Profile
                  </a> */}
                  <a href={`${portalBase}/youth-profile`} id="publicprofile">
                    <i className="fa-regular fa-user cus-fa-fa"></i>&nbsp; Public Profile
                  </a>
                  {/* <a href={public_profile} id="url_calendar">
                    <i className="fa-regular fa-calendar-check cus-fa-fa"></i>&nbsp; Calendar
                  </a> */}
                  <a href={`${portalBase}/discussions/index`} id="url_helpcenter">
                    <i className="fa-regular fa-circle-question cus-fa-fa"></i>&nbsp; Help Center
                  </a>
                  <a href={`${portalBase}/discussions/discussion_forum`} id="url_discussion">
                    <i className="fa-regular fa-comments cus-fa-fa"></i>&nbsp; Discussion
                  </a>
                  <a href={`${portalBase}/users/check_user_logout`} id="logout">
                    <i className="fa-solid fa-arrow-right-from-bracket cus-fa-fa-red"></i>&nbsp; Log
                    Out
                  </a>
                </div>
              </div>
              <div></div>
              <div></div>
            </div>
          </div>
          {/* 
        <div className="flex items-center justify-center gap-x-1 lg:mx-auto">
          <Button asChild size="icon" variant="ghost">
            <Link to="/dashboard/resumes">
              <HouseSimple />
            </Link>
          </Button>

          <span className="mr-2 text-xs opacity-40">{"/"}</span>

          <h1 className="font-medium">{title}</h1>

          {locked && (
            <Tooltip content={t`This resume is locked, please unlock to make further changes.`}>
              <Lock size={14} className="ml-2 opacity-75" />
            </Tooltip>
          )}
        </div> */}
        </div>

        <div className="bars-light">
          <div className="flex items-center justify-between">
            <Button
              size="icon"
              variant="ghost"
              className="flex lg:hidden sb-icon"
              onClick={() => onToggle("left")}
            >
              Edit
              {/* <SidebarSimple className="left-sb" /> */}
            </Button>

            <Button
              size="icon"
              variant="ghost"
              className="flex lg:hidden sb-icon"
              onClick={() => onToggle("right")}
            >
              Templates
              {/* <SidebarSimple className="-scale-x-100 right-sb" /> */}
            </Button>
          </div>
        </div>
      </div>

      <div style={mobheader}>
        <div className="bars-light">
          <div className="flex items-center justify-between">
            <Button
              size="icon"
              variant="ghost"
              className="flex lg:hidden sb-icon"
              onClick={() => onToggle("left")}
            >
              Edit
              {/* <SidebarSimple className="left-sb" /> */}
            </Button>

            <Button
              size="icon"
              variant="ghost"
              className="flex lg:hidden sb-icon"
              onClick={() => onToggle("right")}
            >
              Templates
              {/* <SidebarSimple className="-scale-x-100 right-sb" /> */}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
